import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./reducers";
import createSagaMiddleware from "redux-saga";
import { watchSagas } from "./sagas";
import { saveState, loadState } from "./localstorage";
const saga = createSagaMiddleware();
//redux dev tool
const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;
const enhancer = composeEnhancers(applyMiddleware(saga));

const persistedState = loadState();

const store = createStore(reducers, persistedState, enhancer);
// Debounced store subscription to prevent infinite loops
let saveTimeout;
store.subscribe(() => {
  // Clear previous timeout
  if (saveTimeout) {
    clearTimeout(saveTimeout);
  }
  
  // Debounce saving to prevent infinite loops
  saveTimeout = setTimeout(() => {
    const currentState = store.getState();
    
    // Only save essential data to prevent loops
    const stateToSave = {
      cart: currentState.cart,
      order: {
        orderId: currentState.order.orderId,
        paymentId: currentState.order.paymentId,
        orderHistory: currentState.order.orderHistory,
      },
      location: {
        latitude: currentState.location.latitude,
        longitude: currentState.location.longitude,
      },
      user: currentState.user,
      app: currentState.app,
    };
    
    // Only include hotel if it has valid data and won't cause loops
    if (currentState.hotel && currentState.hotel.hotelKey) {
      stateToSave.hotel = currentState.hotel;
    }
    
    saveState(stateToSave);
  }, 100); // 100ms debounce
});

saga.run(watchSagas);

export default store;
